export default __webpack_public_path__ + "static/media/logo.8c06c2d4.png";